import api from './api';

/**
 * 档口收货地址管理 API
 */
const addressApi = {
  /**
   * 获取所有地址列表
   */
  getList() {
    return api.get('/stall/addresses');
  },
  
  /**
   * 获取默认地址
   */
  getDefault() {
    return api.get('/stall/addresses/default');
  },
  
  /**
   * 创建地址
   */
  create(data) {
    return api.post('/stall/addresses', data);
  },
  
  /**
   * 更新地址
   */
  update(id, data) {
    return api.put(`/stall/addresses/${id}`, data);
  },
  
  /**
   * 设置默认地址
   */
  setDefault(id) {
    return api.put(`/stall/addresses/${id}/default`);
  },
  
  /**
   * 删除地址
   */
  delete(id) {
    return api.delete(`/stall/addresses/${id}`);
  }
};

export default addressApi;
